"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo, useState } from "react";
import NFTImage from "@/components/nft-image/NFTImage";
import { getMediaType } from "@/components/nft-image/utils/media-type";
import type { NFTWithMemesExtendedData } from "@/entities/INFT";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import InteractiveIcon from "@/components/drops/media/InteractiveIcon";
interface NowMintingArtworkProps {
  readonly nft: NFTWithMemesExtendedData;
}
export default function NowMintingArtwork(t0) {
  const $ = _c(17);
  const {
    nft
  } = t0;
  const {
    hasTouchScreen
  } = useDeviceInfo();
  let t1;
  if ($[0] !== nft) {
    t1 = getMediaType(nft, true);
    $[0] = nft;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isHtml = t1 === "html";
  const [hasMounted, setHasMounted] = useState(false);
  const shouldGate = hasTouchScreen && isHtml;
  const [interactiveEnabled, setInteractiveEnabled] = useState(false);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setHasMounted(true);
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setInteractiveEnabled(false);
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== nft.id || $[6] !== shouldGate) {
    t5 = [nft.id, shouldGate];
    $[5] = nft.id;
    $[6] = shouldGate;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  useEffect(t4, t5);
  let shouldAnimate = true;
  if (isHtml) {
    shouldAnimate = hasMounted && (interactiveEnabled || !shouldGate);
  }
  let t6;
  if ($[8] !== nft || $[9] !== shouldAnimate) {
    t6 = <NFTImage nft={nft} animation={shouldAnimate} height={650} transparentBG={true} showBalance={false} />;
    $[8] = nft;
    $[9] = shouldAnimate;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== interactiveEnabled || $[12] !== shouldGate) {
    t7 = shouldGate && !interactiveEnabled && <button type="button" onClick={() => setInteractiveEnabled(true)} className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-transparent" aria-label="Load interactive artwork"><span className="tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-rounded-full tw-border tw-border-white/20 tw-bg-iron-950/90 tw-px-4 tw-py-2 tw-text-xs tw-font-semibold tw-text-white tw-shadow-[0_16px_40px_rgba(0,0,0,0.65)] tw-ring-1 tw-ring-white/10 tw-transition hover:tw-bg-iron-900"><InteractiveIcon className="tw-size-4 tw-flex-shrink-0" />Tap to load</span></button>;
    $[11] = interactiveEnabled;
    $[12] = shouldGate;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6 || $[15] !== t7) {
    t8 = <div className="tw-flex tw-w-full tw-items-start tw-justify-center"><div className="tw-relative tw-w-full">{t6}{t7}</div></div>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}